import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Stop,
} from 'react-native-svg'

const SecureFilled = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        d="M16.95 4.967a.691.691 0 0 0-.225-.467.686.686 0 0 0-.484-.167c-3.274.217-5.791-2.091-5.816-2.116a.667.667 0 0 0-.934.025c-2.158 2.266-5.7 2.083-5.733 2.083a.686.686 0 0 0-.483.167.69.69 0 0 0-.225.458c-.275 5.408.308 11.167 6.783 12.883a.633.633 0 0 0 .175.025c.059 0 .117 0 .175-.025 6.467-1.716 7.058-7.483 6.784-12.883l-.017.017ZM13.2 8.558l-3.75 3.75a.62.62 0 0 1-.434.184.586.586 0 0 1-.433-.184L6.8 10.525a.619.619 0 1 1 .875-.875l1.35 1.342 3.316-3.317a.619.619 0 1 1 .876.875l-.017.008Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={10.008}
        x2={10.008}
        y1={2.038}
        y2={17.858}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#76C686" />
        <Stop offset={1} stopColor="#74A368" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default SecureFilled
